<template>
  <div class="main-frame">
    <div class="info-frame">
      <van-nav-bar title="SMOK" class="top_bar" fixed @click-left="backHome()">
        <template #title>
          <img class="logo-img" src="../assets/image/smoklogo.png" />
        </template>
        <template #left>
          <van-icon name="arrow-left" size="20" color="#000" />
        </template>
      </van-nav-bar>
      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 状态图片 -->
      <img class="title-img" src="../assets/image/img_fake.png" />
      <!-- 提示信息 -->
      <P class="info-msg-01">{{ $t("message.B_fake_fail") }}</P>
      <P class="info-msg-02">{{ msg }}</P>
      <!-- 重新扫描B码按钮 -->
      <van-button class="rescan-btn" type="info" color="#30b3f0" @click="handleScan()">{{
        $t("message.B_fake_btn_scan")
      }}</van-button>
      <!-- 举报按钮 -->
      <van-button
        class="activate-btn"
        type="info"
        color="#30b3f0"
        @click="handleInform()"
        >{{ $t("message.A_fake_counterfeits") }}</van-button
      >
      <!-- APP下载 -->
      <van-button
        icon="wap-home-o"
        type="info"
        color="#30b3f0"
        class="download-btn"
        @click="downloadApp"
        >{{ $t("message.home_button_app") }}</van-button
      >
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import foot from "@/components/Foot.vue";
export default {
  components: {
    foot,
  },
  name: "B_fake",
  data() {
    return {
      text: {},
      msg: "",
    };
  },
  methods: {
    backHome() {
      this.$router.push({ name: "bind-home" });
    },
    downloadApp() {
      this.$router.push({ name: "home" });
    },
    handleInform() {
      this.$router.push({ name: "inform", params: { data: this.text } });
    },
    handleScan() {
      // this.$router.push({name: 'scan', params: {data: this.text}});
      this.$router.push({ name: "A_nonactivate", params: { data: this.text } });
    },
  },
  created() {
    if (this.$route.params.data != undefined) {
      this.text = this.$route.params.data;
      this.msg = this.$route.params.msg;
    } else {
      this.$router.push({ name: "bind-home" });
    }
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.title-img {
  width: 90px;
  height: 90px;
  margin-top: 60px;
}

.info-msg-01 {
  margin-left: 30px;
  margin-top: 30px;
  font-size: 14pt;
  font-weight: bold;
  color: #f64b49;
  width: calc(100% - 60px);
}

.info-msg-02 {
  margin-left: 30px;
  margin-top: 4px;
  font-size: 14pt;
  font-weight: bold;
  width: calc(100% - 60px);
}

.rescan-btn {
  margin-top: 80px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.activate-btn {
  margin-top: 20px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.download-btn {
  margin-top: 16px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}
</style>
